import i18next from 'i18next'
import * as Locales from 'date-fns/locale'
import { Locale } from 'date-fns'

/**
 * Reference from i18Next documentation: https://www.i18next.com/translation-function/formatting#datetime
 * Tested below code and got date formats for each country code from here:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#try_it
 * const date = new Date();
 * console.log(new Intl.DateTimeFormat('en'|'fr'|'it'|'ja'|'zh'|'ko',{ year: 'numeric',day: '2-digit', month: '2-digit'}).format(date));
 */

export const getDateFormatByLocale = () => {
  //These formats are needed for DatePicker component
  switch (i18next.language) {
    case 'en':
      return 'MM/dd/yyyy'
    case 'fr':
      return 'dd/MM/yyyy'
    case 'it':
      return 'dd/MM/yyyy'
    case 'zh':
      return 'yyyy/MM/dd'
    case 'ko':
      return 'yyyy. MM. dd.'
    case 'ja':
      return 'yyyy/MM/dd'
    default:
      console.log(
        `${i18next.language} is not supported yet, falling back to 'MM/dd/yyyyy' for date.`
      )
      return 'MM/dd/yyyy'
  }
}

/**
 *
 * @returns date picker locale for the selected i18n language
 * falls back to US English, if language's locale not found
 */
export const getDatePickerFormatByLocale = (): Locale => {
  return Locales[i18next.language] ?? Locales.enUS
}

export const getDateTimeStampFormatByLocale = () => {
  //These formats are needed for DatePicker component
  switch (i18next.language) {
    case 'en':
      return {
        date: getDateFormatByLocale(),
        time: 'HH:MM:SS'
      }
    case 'fr':
      return {
        date: getDateFormatByLocale(),
        time: 'hh:mm:ss A'
      }
    case 'it':
      return {
        date: getDateFormatByLocale(),
        time: 'hh:mm:ss A'
      }
    case 'zh':
      return {
        date: getDateFormatByLocale(),
        time: 'hh:mm:ss A'
      }
    case 'ko':
      return {
        date: getDateFormatByLocale(),
        time: 'hh:mm:ss a'
      }
    case 'ja':
      return {
        date: getDateFormatByLocale(),
        time: 'hh:mm:ss A'
      }
    default:
      return {
        date: getDateFormatByLocale(),
        time: 'hh:mm:ss a'
      }
  }
}
